<template>
  <div class="ChangePassword">
    <cell-group>
      <cell title="ID" :value="mid" />
      <cell title="姓名" :value="info.trueName" />
      <cell title="手机" :value="info.phone" />
      <!--      <cell title="性别" :value="info.sex == 1?'男':'女'" />-->
      <cell title="卡号" :value="info.number" />
      <cell title="生日" :value="info.birthDay" />
      <cell title="地址" :value="info.address" />
      <cell title="门店" :value="info.shopName" />
    </cell-group>
    <div class="confirmBnt bg-color-red" @click="confirm">确认绑定</div>
  </div>
</template>
<script>
import { CellGroup, Cell, Toast } from "vant";
import { mapGetters } from "vuex";
import { get, bindWX } from "@api/member";
import { clearAuthStatus } from "@libs/wechat";

export default {
  name: "BindingWeixin",
  components: { CellGroup, Cell },
  props: {},
  data: function () {
    return {
      mid: this.$route.query.mid,
      showSubscribe: false,
      info: {},
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function () {
    get(this.mid).then((res) => {
      this.info = res.result;
    });
  },
  methods: {
    confirm() {
      bindWX(this.mid).then((res) => {
        if (res.code == 200) {
          Toast("绑定成功！");
          this.$store.commit("LOGOUT");
          clearAuthStatus();
          // this.$router.replace({ path: "/user" });
          this.$router.replace({ path: "/user/subscribe" });
          // location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzNTI1MTA4OQ==&scene=110#wechat_redirect'
          // this.showSubscribe = true
        } else {
          Toast(res.message);
        }
      });
    },
  },
};
</script>
